import { observer } from 'mobx-react-lite';
import { Base } from 'zf-web-components';
import { CONFIG } from 'config';
import { useEffect } from 'react';
import { useContent } from '@hooks';
import { useApp } from '@components';
import { Form } from './components/form';
import { Header } from './components/header';
import { LoginStore } from './store';
import styles from './index.module.less';
import type { ReactElement } from 'react';

function LoginPage(): ReactElement {
  if (window.top != null && window.top !== window.self) {
    window.top.location.href = window.location.href;
  }
  const { app, colorPrimary, name } = useApp();
  const { store } = useContent(LoginStore)();
  const backgroundImage = { backgroundImage: `url(${CONFIG.IMAGE_STATIC}/${app}_bg@2x.png)` };
  const mainImage = { backgroundImage: `url(${CONFIG.IMAGE_STATIC}/${app}_login@2x.png)` };
  const color = store.hexToRgb(colorPrimary, 0.1);
  const formStyle = {
    boxShadow: `0 4px 64px 0 ${color}`
  };

  useEffect(() => {
    document.title = name;
  }, []);

  return (
    <Base.Layout className={styles.loginContainer} style={backgroundImage}>
      <main className={styles.container}>
        <div className={styles.headerWrap}>
          <Header />
        </div>
        <Base.Row className={styles.bodyWrap}>
          <Base.Col
            className={styles.left}
            style={mainImage}
            xs={0}
            md={0}
            lg={12}
            xl={12}
            xxl={12}
          >
          </Base.Col>
          <Base.Col
            className={styles.right}
            xs={24}
            md={24}
            lg={12}
            xl={12}
            xxl={12}
          >
            <div className={styles.formContainer} style={formStyle}>
              <Form store={store} />
            </div>
          </Base.Col>
        </Base.Row>
      </main>
    </Base.Layout>
  );
}

export default observer(LoginPage);
